export const userActions = {
    ADD_USER: 'addUser',
    ADD_USERS: 'addUsers',
    EDIT_USER: 'editUser',
    USER_DETAILS: 'userDetails',
    DELETE_USERS: 'deleteUsers',
    DELETE_ADMINS_INVALID: 'deleteAdminsInvalid',
    DELETE_YOURSELF_INVALID: 'deleteYourselfInvalid',
    DISABLE_USERS: 'disableUsers',
    TRANSFER_PRIMARY_ACCOUNT: 'transferPrimaryAccount',
    ENABLE_USERS: 'enableUsers',
    APPROVE_PENDING: 'approvePending',
    APPROVE_PENDING_INVALID: 'invalidApproveErrorModal',
    CONVERT_TO_PERSONAL: 'convertToPersonal',
    REQUIRE_PASSWORD_CHANGE: 'requirePasswordChange',
    RESET_PASSWORD: 'resetPassword',
    RESET_PASSWORD_SUCCESS: 'resetPasswordSuccess',
    RESET_PASSWORD_CONFIRMATION: 'resetPasswordConfirmation',
    RESET_PASSWORD_ERROR: 'resetPasswordError',
    MANAGE_IN_PASSWORDBOSS: 'manageInPasswordBoss',
    DISABLE_USER_2FA: 'disableUser2fa',
};
